import { render } from "./changeSuccessfully.vue?vue&type=template&id=01dff98b"
import script from "./changeSuccessfully.vue?vue&type=script&lang=js"
export * from "./changeSuccessfully.vue?vue&type=script&lang=js"

import "./changeSuccessfully.vue?vue&type=style&index=0&id=01dff98b&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__